import { render } from "./Question.vue?vue&type=template&id=24509cb3"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=24509cb3&lang=scss"

import exportComponent from "/Users/elkemoras/Desktop/sites/www/ugent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__